<template>
<section class="section portfolio">
    <div class="container">
        <header class="section-header">
            <h2 class="title is-2">{{section_data.title}}</h2>
            <span><i></i><i></i><i></i></span>
        </header>
        <div :class="['columns is-multiline is-variable is-4', {'is-mobile': !is_mobile}]">
            <div class="column is-4" v-for="work in section_data.works">
                <div class="portfolio__work">
                    <h3 class="title">{{work.title}}</h3>
                    <p class="subtitle">{{work.subtitle}}</p>
                    <div class="content" v-if="work.content" v-html="work.content"></div>
                    <div class="content" v-if="work.client || work.workat">
                        <p><template v-if="work.client"><strong>Client</strong>: {{work.client}}</template>
                            <br v-if="work.workat" /><template v-if="work.workat"><strong>via</strong>: {{work.workat}}</template>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import PosHandler from '../../mixins/PosHandler';
export default {
    name        :   'PortfolioSection',
    props       :   ['section_data', 'is_mobile'],
    mixins      :   [ PosHandler ]
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/sections/PortfolioSection.vue